module.exports = __webpack_public_path__ + "static/media/desktop-sidebar.11ff10bd.png";